// Registers the runtime MF remotes from app settings; the only config module importing the MF runtime.
import { registerRemotes } from '@module-federation/enhanced/runtime';

// Both remotes are statically imported by the bootloader, so both are required at boot.
const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** Register every runtime remote from app settings; returns false if a required remote's URL is missing. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      if (required) missingRequired.push(settingKey);
      else console.error(`[transportation-network-ui] ${settingKey} missing; skipping ${name} remote`);
      return;
    }
    const origin = value.trim().replace(/\/$/, '');
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return missingRequired.length === 0;
}
